import { render, staticRenderFns } from "./PaginatedTableBase.vue?vue&type=template&id=8f2d9b96"
import script from "./PaginatedTableBase.vue?vue&type=script&lang=js"
export * from "./PaginatedTableBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports